// Dummy data untuk Portal DPL
// Proses Bisnis: 1 DPL membimbing 1 BUMDes dengan banyak Project Officer
// Catatan:
// 1. Survey VECI bersifat 1 VECI per 1 Lembaga (BUMDes), bukan per PO.
// 2. BMC bersifat 1 BMC per 1 Lembaga (BUMDes), dikerjakan secara kolaboratif (bergantian) oleh para PO.

export const DUMMY_BUMDES = {
  id: 1,
  name: 'BUMDes Maju Bersama',
  region: 'Desa Karang Tengah, Kec. Rawalo, Kab. Banyumas, Jawa Tengah',
  established: '12 Februari 2018',
  batch: 'Batch 5 · 2026',
  programStartDate: '1 Maret 2026',
  programEndDate: '31 Agustus 2026',
  
  // VECI is 1 per BUMDes
  veci: {
    t0: {
      score: 22.40, // (3.6 + 3.4) * 3.2
      submittedAt: '15 Maret 2026',
      status: 'APPROVED',
      filler: 'Andi Prasetyo (PO)',
      dimensions: {
        OP: 3.6,
        AD: 3.4,
        MP: 3.2,
        S: 4.0,
        E: 3.8,
      }
    },
    t1: {
      score: 28.80, // (4.2 + 3.8) * 3.6
      submittedAt: '20 Mei 2026',
      status: 'APPROVED',
      filler: 'Sari Dewi Lestari (PO)',
      dimensions: {
        OP: 4.2,
        AD: 3.8,
        MP: 3.6,
        S: 4.2,
        E: 4.0,
      }
    },
    t2: {
      score: null,
      submittedAt: null,
      status: 'BELUM MULAI',
      filler: null,
      dimensions: null
    },
  },

  // BMC is 1 per BUMDes (Collaborative, gantian antar PO)
  bmc: {
    status: 'Direvisi',
    currentVersion: 4,
    lastUpdate: '25 Mei 2026',
    feedback: 'Struktur biaya (Cost Structure) dan Aliran Pendapatan (Revenue Streams) perlu diselaraskan kembali dengan rencana pengembangan unit agrowisata baru.',
    history: [
      {
        version: 4,
        status: 'Direvisi',
        updatedAt: '25 Mei 2026',
        updatedBy: 'Bagas Wicaksono (PO)',
        notes: 'Mengajukan draf revisi penambahan unit agrowisata baru.',
        feedback: 'Struktur biaya (Cost Structure) dan Aliran Pendapatan (Revenue Streams) perlu diselaraskan kembali dengan rencana pengembangan unit agrowisata baru.'
      },
      {
        version: 3,
        status: 'Direvisi',
        updatedAt: '20 Mei 2026',
        updatedBy: 'Andi Prasetyo (PO)',
        notes: 'Mengubah segmentasi pasar ke regional Banyumas.',
        feedback: 'Segmen pelanggan masih terlalu luas, tolong dipersempit ke pasar lokal Banyumas.'
      },
      {
        version: 2,
        status: 'Draft',
        updatedAt: '15 Mei 2026',
        updatedBy: 'Sari Dewi Lestari (PO)',
        notes: 'Mengisi value proposition baru untuk BUMDes.',
        feedback: null
      },
      {
        version: 1,
        status: 'Draft',
        updatedAt: '10 Mei 2026',
        updatedBy: 'Rizky Nugroho (PO)',
        notes: 'Inisiasi draf awal BMC BUMDes bersama jajaran direksi.',
        feedback: null
      }
    ]
  }
};

export const DUMMY_PO_LIST = [
  {
    id: 1,
    name: 'Andi Prasetyo',
    university: 'Universitas Jenderal Soedirman',
    faculty: 'Fakultas Ekonomi & Bisnis',
    email: 'andi.prasetyo@unsoed.ac.id',
    phone: '081234567890',
    avatar: 'A',
    color: '#4f46e5',
    onePager: [
      { month: 'Maret 2026', submitted: true, date: '2 Apr 2026' },
      { month: 'April 2026', submitted: true, date: '5 Mei 2026' },
      { month: 'Mei 2026', submitted: true, date: '3 Jun 2026' },
      { month: 'Juni 2026', submitted: false, date: null },
    ],
    escalations: [
      { id: 'E-001', date: '22 Mei 2026', issue: 'Butuh data keuangan BUMDes periode 2024 untuk analisis BMC', priority: 'high', status: 'open' },
    ],
    lastActivity: '22 Mei 2026',
    status: 'attention',
  },
  {
    id: 2,
    name: 'Sari Dewi Lestari',
    university: 'Universitas Brawijaya',
    faculty: 'Fakultas Ilmu Administrasi',
    email: 'sari.dewi@ub.ac.id',
    phone: '082345678901',
    avatar: 'S',
    color: '#0891b2',
    onePager: [
      { month: 'Maret 2026', submitted: true, date: '1 Apr 2026' },
      { month: 'April 2026', submitted: true, date: '3 Mei 2026' },
      { month: 'Mei 2026', submitted: true, date: '1 Jun 2026' },
      { month: 'Juni 2026', submitted: true, date: '2 Jul 2026' },
    ],
    escalations: [],
    lastActivity: '25 Mei 2026',
    status: 'active',
  },
  {
    id: 3,
    name: 'Rizky Nugroho',
    university: 'Universitas Gadjah Mada',
    faculty: 'Fakultas Geografi',
    email: 'rizky.nugroho@ugm.ac.id',
    phone: '083456789012',
    avatar: 'R',
    color: '#059669',
    onePager: [
      { month: 'Maret 2026', submitted: true, date: '4 Apr 2026' },
      { month: 'April 2026', submitted: false, date: null },
      { month: 'Mei 2026', submitted: false, date: null },
      { month: 'Juni 2026', submitted: false, date: null },
    ],
    escalations: [
      { id: 'E-002', date: '19 Mei 2026', issue: 'Kesulitan mengumpulkan data primer dari anggota BUMDes', priority: 'medium', status: 'open' },
      { id: 'E-003', date: '24 Mei 2026', issue: 'Akses ke kantor BUMDes dibatasi, perlu surat izin dari program', priority: 'high', status: 'open' },
    ],
    lastActivity: '24 Mei 2026',
    status: 'attention',
  },
  {
    id: 4,
    name: 'Mega Puspita',
    university: 'Institut Pertanian Bogor',
    faculty: 'Fakultas Ekonomi & Manajemen',
    email: 'mega.puspita@ipb.ac.id',
    phone: '084567890123',
    avatar: 'M',
    color: '#d97706',
    onePager: [
      { month: 'Maret 2026', submitted: true, date: '1 Apr 2026' },
      { month: 'April 2026', submitted: true, date: '2 Mei 2026' },
      { month: 'Mei 2026', submitted: true, date: '2 Jun 2026' },
      { month: 'Juni 2026', submitted: false, date: null },
    ],
    escalations: [],
    lastActivity: '26 Mei 2026',
    status: 'active',
  },
  {
    id: 5,
    name: 'Bagas Wicaksono',
    university: 'Universitas Negeri Yogyakarta',
    faculty: 'Fakultas Ilmu Sosial',
    email: 'bagas.wicaksono@uny.ac.id',
    phone: '085678901234',
    avatar: 'B',
    color: '#7c3aed',
    onePager: [
      { month: 'Maret 2026', submitted: true, date: '3 Apr 2026' },
      { month: 'April 2026', submitted: true, date: '4 Mei 2026' },
      { month: 'Mei 2026', submitted: false, date: null },
      { month: 'Juni 2026', submitted: false, date: null },
    ],
    escalations: [
      { id: 'E-004', date: '25 Mei 2026', issue: 'PO membutuhkan template One Pager terbaru dari tim program', priority: 'low', status: 'open' },
    ],
    lastActivity: '25 Mei 2026',
    status: 'active',
  },
];
